export const SELECT_PRODUCT_LIFE_READY = 'SELECT_PRODUCT_LIFE_READY'
export const SELECT_PRODUCT_CANCERX5 = 'SELECT_PRODUCT_CANCERX5'
export const SELECT_PRODUCT_KOOMVER_COVER = 'SELECT_PRODUCT_KOOMVER_COVER'
export const SELECT_PRODUCT_KOOMVER_COMPENSATE = 'SELECT_PRODUCT_KOOMVER_COMPENSATE'
export const SELECT_PRODUCT_LIFE_TREASURE = 'SELECT_PRODUCT_LIFE_TREASURE'

export const selectProductLifeReady = (productCode) => ({
  type: SELECT_PRODUCT_LIFE_READY,
  payload: productCode,
})

export const selectProductLifeTreasure = (productCode) => ({
  type: SELECT_PRODUCT_LIFE_TREASURE,
  payload: productCode,
})

export const selectProductCancerX5 = (productCode) => ({
  type: SELECT_PRODUCT_CANCERX5,
  payload: productCode,
})

export const selectProductKoomverCover = (productCode) => ({
  type: SELECT_PRODUCT_KOOMVER_COVER,
  payload: productCode,
})

export const selectProductKoomverCompensate = (productCode) => ({
  type: SELECT_PRODUCT_KOOMVER_COMPENSATE,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
